import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  uid: string;
  name?: string;
  email?: string;
  company?: string;
  lastLogin?: string;
  initials?: string;
  initialQuiz?: false;
  selfEfficacyQuiz?: boolean;
  module?: string;
  avatarSimulation?: number;
  p2pSimulation?: number;
  p2pScheduled?: string;
  approved?: boolean;
  displayCompany?: boolean;
  companies?: [];
}

export interface Assessment {
  feedback: {
    pre_training: any;
  };
  general: {
    initial_survey: any;
  };
}

export interface Journey {
  current_module: string;
}

export interface Attempt {
  completed: boolean;
  approved: boolean;
}

export interface UserSimulations {
  attempts: Attempt[];
}

@Component({
  selector: 'app-user-detail-dialog',
  templateUrl: './user-detail-dialog.component.html',
  styleUrls: [],
})
export class UserDetailDialogComponent implements OnInit {
  
  approved = false;
  declare assessment: Assessment;
  declare journey: Journey;
  declare scheduledSimulations: any[];
  declare userSimulations: any[];
  avatarSimulations = 0;
  p2pSimulations = 0;
  isLoading = true;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogData>,
  ) {
  }
  
  ngOnInit() {
    console.log(this.data);
    this.avatarSimulations = this.data.feedback?.simulations_avatar || 0;
    this.p2pSimulations = this.data.feedback?.simulations_peers || 0;
    
    this.isLoading = false;
  }
  
  closeDialog() {
    this.dialogRef.close();
  }
  
  get initialSurvey() {
    return this.data.assessments?.general?.initial_survey || false;
  }
  
  get preTraining() {
    return this.data.assessments?.feedback?.pre_training || false;
  }
}
